/* eslint-disable no-magic-numbers */
import { Badge } from '@mantine/core';

interface AIResultSuccessProps {
    value: number | null;
}

const AIResultSuccess = ({ value }: AIResultSuccessProps) => {
    if (value === 1) {
        return (
            <Badge color="green.6" variant="filled">
                Success-A
            </Badge>
        );
    }

    if (value === 2) {
        return (
            <Badge color="green.5" variant="filled">
                Success-B
            </Badge>
        );
    }
    return <Badge variant="default">No</Badge>;
};

export default AIResultSuccess;
